import IconButton from '@material-ui/core/Button';
import React from 'react';
import DescriptionIcon from '@material-ui/icons/Description';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import ImageIcon from '@material-ui/icons/Image';
import MovieCreationIcon from '@material-ui/icons/MovieCreation';
import FolderIcon from '@material-ui/icons/Folder';
import useTableButtonStyle from './TableButtonStyle';

const FileButton = (props) => {
    const { path, setSelectedFileSystemNodePath, fileSystemNodeType } = props;
    const classes = useTableButtonStyle();

    const handleClick = () => {
        setSelectedFileSystemNodePath(path, fileSystemNodeType);
    }
    return (<>
        <IconButton size="small" className={classes.root} onClick={handleClick}>
            { getIconComponent(fileSystemNodeType) }
        </IconButton>
    </>);
}

const getIconComponent = (type) => {
    switch (type) {
        case 'directory':
            return <FolderIcon size="small"/>
        case 'audio':
            return <VolumeUpIcon/>
        case 'image':
            return <ImageIcon/>
        case 'video':
            return <MovieCreationIcon/>
        case 'document':
            return <DescriptionIcon/>
    }
}

export default FileButton;